<template>
  <div class="section">
    <h1 class="title">{{ user.fullName }}</h1>
    <h1 class="subtitle">
      Welcome to the admin panel
      <button class="button logout is-text" @click="logout">
        <span class="icon is-small">
          <i class="fas fa-sign-out-alt"></i>
        </span>
        <span>Logout</span>
      </button>
    </h1>

    <div class="container is-fluid">
      <div class="tabs is-boxed is-centered">
        <ul>
          <li
            v-for="(tab, i) in tabs"
            :key="i"
            :class="[tab.isActive ? 'is-active' : '']"
          >
            <a @click="SET_ACTIVE_TAB(tab.table)" v-html="tab.name"></a>
          </li>
        </ul>
      </div>
      <component :is="activeTab.childComponent" />
    </div>
    <Pagination size="10" start="1" />
    <ModalManager />
  </div>
</template>

<script>
import Dashboard from "../components/Dashboard/Dashboard.vue";
import userList from "../components/UserList.vue";
import companyList from "../components/CompanyList.vue";
import projectList from "../components/ProjectList.vue";
import cameraList from "../components/CameraList.vue";
import Pagination from "../components/Pagination.vue";
import contractList from "../components/ContractList.vue";
import videoOrderList from "../components/VideoOrderList.vue";
import proCameraInventoryList from "../components/ProCameraInventoryList.vue";
import ModalManager from "../components/ModalManager.vue";
import ComponentList from "@/components/ComponentList.vue";

import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { DEVICE_STATUSES } from "@/utils/pro_camera";

const SORT_COLUMNS = ["id", "serial_number", "status", "last_seen_at"];

export default {
  components: {
    ComponentList,
    Dashboard,
    userList,
    companyList,
    projectList,
    cameraList,
    contractList,
    videoOrderList,
    proCameraInventoryList,
    ModalManager,
    Pagination,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["user", "tabs", "search", "filters", "proCameraSort"]),
    ...mapGetters(["activeTab", "activeTabIndex", "availableTabs"]),
    // Everything a refresh should restore; defaults are left out to keep the URL short.
    urlState() {
      const state = { tab: this.activeTab.table, page: String(this.activeTab.currentPage || 1) };
      if (this.search) state.search = this.search;
      if (this.activeTab.table === "pro_camera_inventories") {
        if (this.filters.status) state.status = this.filters.status;
        if (this.proCameraSort.by !== "id" || this.proCameraSort.order !== "desc") {
          state.sort = this.proCameraSort.by;
          state.order = this.proCameraSort.order;
        }
      }
      return state;
    },
  },
  methods: {
    ...mapActions(["logout"]),
    ...mapMutations(["SET_ACTIVE_TAB", "SET_CURRENT_PAGE", "SET_SEARCH", "SET_FILTERS_STATUS", "SET_PRO_CAMERA_SORT"]),
  },
  watch: {
    // Keep the open tab, page, search, filter and sort in the URL so a refresh or a shared link reopens them.
    urlState(state) {
      if (JSON.stringify(state) === JSON.stringify(this.$route.query)) return;
      this.$router.replace({ query: state }).catch(() => {});
    },
  },
  created() {
    const { tab: table, page, search, status, sort, order } = this.$route.query;
    if (table && this.tabs.some((tab) => tab.table === table)) this.SET_ACTIVE_TAB(table);
    if (search) this.SET_SEARCH(String(search));
    if (DEVICE_STATUSES.some((item) => item.value === status)) this.SET_FILTERS_STATUS(status);
    if (SORT_COLUMNS.includes(sort) && ["asc", "desc"].includes(order)) this.SET_PRO_CAMERA_SORT({ by: sort, order });
    const pageNumber = Number(page);
    if (Number.isInteger(pageNumber) && pageNumber > 1) {
      this.SET_CURRENT_PAGE({ tabIndex: this.activeTabIndex, page: pageNumber });
    }
  },
  mounted() {},
};
</script>

<style scoped>
.button.logout {
  margin-top: -0.5rem;
}
</style>
